<div class="alert alert-danger custom-error" role="alert">
    <h4 class="alert-heading mt-2">Errore!</h4>
    <div class="modal-body">
        <span class="info-body">
            {{ (errorCode ? 'error-messages.' + errorCode : ( errorMessage || 'error-messages.default') ) | translate}}
        </span>
    </div>
    <div class="pushbuttons mb-3 mr-2">
        <button type="button" class="btn btn-outline-black pull-right buttons"
            (click)="onDecline()">{{'operations.close' | translate }}</button>
        <button *ngIf="retryCallback" type="button" class="btn btn-outline-black pull-right buttons mr-3"
            (click)="onRetry()">{{'operations.retry' | translate }}</button>
    </div>
</div>